import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, TableCell, Tooltip, Icon} from '@material-ui/core'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { Datatable, DatatableToolbar, DatatableHead, DatatableBody } from 'src/shared/Datatable'
import { TableSortCell } from 'src/shared/TableSort'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import DatatableRow from 'src/shared/Datatable/DatatableRow'
import { fetchTransactionsDette } from 'src/core/redux/action/transactionsAction'
import { ITransactionDette, ITransactionPlacement, ITransactionChange} from 'src/type/transaction'
import { generateTableCell } from 'src/shared/utils/helpers'
import { TransactionCriteria } from 'src/type/criteria/transactionCriteria'
import DatatableFilters from 'src/shared/Datatable/Filters/DatatableFilters'
import DatatableFilterMultipleCustomArray from 'src/shared/Datatable/Filters/DatatableFilterMultipleCustomArray'
import BtnIcon from 'src/shared/BtnIcon/BtnIcon'
import {css} from 'src/conf/style'
import {config} from 'src/conf/config'
import { get } from 'lodash'

const styles = (t: Theme) => createStyles({
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    },
    tableWpr: {
        width: '100%',
        overflow: 'auto'
    },
    actions: {
        ...css.flexJcEnd,
        marginBottom: t.spacing.unit*2
    },
    consultDoc: {
        fontSize: '13px', 
        color: '#ed1c24', 
        cursor: 'pointer'
    },
    document: {
        fontSize: 0,
    }
});

const MOCK_DETTE = [
    {name: "numero_du_contrat",                             sortable: true, hidden: false, type: undefined, label: "Transactions.numero_du_contrat" },
    {name: "typologie_operation",                           sortable: false, hidden: false, type: undefined, label: "Transactions.typologie_operation" },
    {name: "type_de_produit",                               sortable: false, hidden: false, type: undefined, label: "Transactions.type_de_produit" },
    {name: "categorie_fo_risque_de_produit",                sortable: false, hidden: true, type: undefined, label: "Transactions.dette.categorie_fo_risque_de_produit" },
    {name: "date_operation",                                sortable: true, hidden: false, type: "date", label: "Transactions.date_operation" },
    {name: "date_de_valeur_operation",                      sortable: true, hidden: false, type: "date", label: "Transactions.date_de_valeur_operation" },
    {name: "date_de_maturite",                              sortable: true, hidden: false, type: "date", label: "Transactions.date_de_maturite" },
    {name: "nominal",                                       sortable: true, hidden: false, type: "currency", label: "Transactions.nominal" },
    {name: "date_de_paiement_du_flux_interet_1",            sortable: false, hidden: false, type: "date", label: "Transactions.dette.date_de_paiement_du_flux_interet_1" },
    {name: "nominal_restant",                               sortable: false, hidden: false, type: "currency", label: "Transactions.nominal_restant" },
    {name: "sens_du_trade_1",                               sortable: false, hidden: false, type: undefined, label: "Transactions.dette.sens_du_trade_1" },
    {name: "devise_1",                                      sortable: false, hidden: false, type: undefined, label: "Transactions.dette.devise_1" },
    {name: "type_de_taux_1",                                sortable: false, hidden: false, type: undefined, label: "Transactions.dette.type_de_taux_1" },
    {name: "taux_1",                                        sortable: false, hidden: false, type: undefined, label: "Transactions.dette.taux_1" },
    {name: "floored_rate_1",                                sortable: false, hidden: false, type: undefined, label: "Transactions.dette.floored_rate_1" },
    {name: "structured_rate_1",                             sortable: false, hidden: false, type: undefined, label: "Transactions.dette.structured_rate_1" },
    {name: "sens_du_trade_2",                               sortable: false, hidden: false, type: undefined, label: "Transactions.dette.sens_du_trade_2" },
    {name: "devise_2",                                      sortable: false, hidden: false, type: undefined, label: "Transactions.dette.devise_2" },
    {name: "niveau_barriere",                               sortable: false, hidden: false, type: undefined, label: "Transactions.dette.niveau_barriere" },
    {name: "type_de_taux_2",                                sortable: false, hidden: false, type: undefined, label: "Transactions.dette.type_de_taux_2" },
    {name: "taux_2",                                        sortable: false, hidden: false, type: undefined, label: "Transactions.dette.taux_2" },
    {name: "floored_rate_2",                                sortable: false, hidden: false, type: undefined, label: "Transactions.dette.floored_rate_2" },
    {name: "structured_rate_2",                             sortable: false, hidden: false, type: undefined, label: "Transactions.dette.structured_rate_2" },
    {name: "date_de_paiement_du_flux_interet_2",            sortable: false, hidden: true, type: "date", label: "Transactions.dette.date_de_paiement_du_flux_interet_2" },
    {name: "prix_exercice_option_1",                        sortable: false, hidden: true, type: undefined, label: "Transactions.dette.prix_exercice_option_1" },
    {name: "style_de_barriere",                             sortable: false, hidden: true, type: undefined, label: "Transactions.dette.style_de_barriere" },
    {name: "niveau_barriere",                               sortable: false, hidden: true, type: undefined, label: "Transactions.dette.niveau_barriere" },
    {name: "strike_option_1",                               sortable: false, hidden: true, type: undefined, label: "Transactions.dette.strike_option_1" },
    {name: "strike_option_2",                               sortable: false, hidden: true, type: undefined, label: "Transactions.dette.strike_option_2" },
    {name: "valorisation_cc",                               sortable: false, hidden: true, type: "currency", label: "Transactions.dette.valorisation_cc" },
    {name: "valorisation_pdc",                              sortable: false, hidden: true, type: "currency", label: "Transactions.dette.valorisation_pdc" },
    {name: "montant_couru",                                 sortable: false, hidden: true, type: "currency", label: "Transactions.dette.montant_couru" },
    {name: "date_valorisation",                             sortable: false, hidden: true, type: "date", label: "Transactions.dette.date_valorisation" },
    {name: "status",                                        sortable: false, hidden: false, type: undefined, label: "Transactions.status" },
]

const paginateName = 'transactionsDette';
const paginateAction = fetchTransactionsDette;
const actions = new PaginateAction<any>(paginateName, paginateAction)

interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
    accessDocuments: (transaction: ITransactionDette | ITransactionPlacement | ITransactionChange) => void,
}

class TransactionsDette extends React.Component<IProps, any> {

    render(){
        const { t, classes, transactionsDette, transactionsDetteCriteria } = this.props;
        return(
            <div className={classes.tableWpr}>
                {transactionsDette &&
                    <>
                        <div className={classes.actions}>
                            <BtnIcon
                                icon="cloud_download"
                                variant="raised"
                                onClick={this.download}
                                color="primary"
                            >
                                {t.export}
                            </BtnIcon>
                        </div>
                        <Datatable
                            name={paginateName}
                            action={paginateAction}
                            defaultHiddenColumns={[false, ...MOCK_DETTE.map(x => x.hidden)]}
                            criteriaDefault={{ sort_by: "numero_du_contrat", order_by: "asc", status: "Live", limit: transactionsDetteCriteria.limit, offset: transactionsDetteCriteria.offset}}
                            paginationPosition="left"
                        >
                            <DatatableFilters float="left">
                                <DatatableFilterMultipleCustomArray
                                    display={t.Transactions.filter_status}
                                    filterBy="status"
                                    selectedDefault={{label: 'LIVE', value: 'Live'}}
                                    items={[
                                        {label: 'DEAD', value: 'Dead'},
                                        {label: 'LIVE', value: 'Live'},
                                    ]}
                                />
                            </DatatableFilters>
                            <DatatableToolbar search="global_search"/>
                            <DatatableHead>
                                <TableCell className={classes.document}>{t.Transactions.document}</TableCell>
                                {MOCK_DETTE.map(m => m.sortable ? (
                                    <TableSortCell name={m.name}>{get(t, m.label, "")}</TableSortCell>
                                ) : (
                                    <TableCell>{get(t, m.label, "")}</TableCell>
                                ))}
                            </DatatableHead>
                            <DatatableBody renderRow={this.renderRow}/>
                        </Datatable>
                    </>
                }
            </div>
        )
    }
    
    @autobind
    private renderRow(t: ITransactionDette) {
        return (
            <DatatableRow>
                <TableCell >
                    <div 
                        style={{display: 'flex', alignItems: 'center'}}
                        className={this.props.classes.consultDoc}
                        onClick={() => this.props.accessDocuments(t)}
                    >
                        <Tooltip title="Consulter les documents" placement="top" style={{marginRight: '5px'}}>
                            <Icon>snippet_folder</Icon>
                        </Tooltip>
                    </div>
                </TableCell>
                <TableCell >{generateTableCell(t.transaction.numero_du_contrat)}</TableCell>
                <TableCell >{generateTableCell(t.transaction.typologie_operation)}</TableCell> 
                <TableCell >{generateTableCell(t.transaction.type_de_produit)}</TableCell>
                <TableCell >{generateTableCell(t.categorie_fo_risque_de_produit)}</TableCell> 
                <TableCell >{generateTableCell(t.transaction.date_operation, 'date')}</TableCell>
                <TableCell >{generateTableCell(t.transaction.date_de_valeur_operation, 'date')}</TableCell>
                <TableCell >{generateTableCell(t.transaction.date_de_maturite, 'date')}</TableCell>
                <TableCell >{generateTableCell(t.transaction.nominal, 'currency')}</TableCell>
                <TableCell >{generateTableCell(t.date_de_paiement_du_flux_interet_1, 'date')}</TableCell> 
                <TableCell >{generateTableCell(t.transaction.nominal_restant, 'currency')}</TableCell> 
                <TableCell >{generateTableCell(t.sens_du_trade_1)}</TableCell> 
                <TableCell >{generateTableCell(t.devise_1)}</TableCell>  
                <TableCell >{generateTableCell(t.type_de_taux_1)}</TableCell>
                <TableCell >{generateTableCell(t.taux_1)}</TableCell> 
                <TableCell >{generateTableCell(t.floored_rate_1)}</TableCell>  
                <TableCell >{generateTableCell(t.structured_rate_1)}</TableCell>  
                <TableCell >{generateTableCell(t.sens_du_trade_2)}</TableCell>  
                <TableCell >{generateTableCell(t.devise_2)}</TableCell>  
                <TableCell >{generateTableCell(t.niveau_barriere)}</TableCell>  
                <TableCell >{generateTableCell(t.type_de_taux_2)}</TableCell>  
                <TableCell >{generateTableCell(t.taux_2)}</TableCell>  
                <TableCell >{generateTableCell(t.floored_rate_2)}</TableCell>  
                <TableCell >{generateTableCell(t.structured_rate_2)}</TableCell> 
                <TableCell >{generateTableCell(t.date_de_paiement_du_flux_interet_2, 'date')}</TableCell> 
                <TableCell >{generateTableCell(t.prix_exercice_option_1)} </TableCell>  
                <TableCell >{generateTableCell(t.style_de_barriere)} </TableCell>  
                <TableCell >{generateTableCell(t.niveau_barriere)} </TableCell>  
                <TableCell >{generateTableCell(t.strike_option_1)} </TableCell>  
                <TableCell >{generateTableCell(t.strike_option_2)} </TableCell> 
                <TableCell >{generateTableCell(t.valorisation_pdc, 'currency')}</TableCell>
                <TableCell >{generateTableCell(t.valorisation_cc, 'currency')}</TableCell>
                <TableCell >{generateTableCell(t.montant_couru, 'currency')}</TableCell>
                <TableCell >{generateTableCell(t.date_valorisation, 'date')}</TableCell>
                <TableCell >{generateTableCell(t.transaction.status)}</TableCell> 
            </DatatableRow>
        )
    }

    componentDidMount(){
        this.props.updateCriteriaByObject({sort_by: "numero_du_contrat", order_by: "asc", status: "Live"})
    }

    @autobind
    private download(){
        const {enterprise} = this.props;
        window.open(`${config.baseUrl}/enterprise/${enterprise.id}/transaction/export/dette`)
    }

}

const state2props = (state: RootState) => ({
    connectedUser: state.accountInfo.connectedUser,
    enterprise: state.accountInfo.enterpriseSelected,
    categories: state.categories.entities,
    mapName: state.utils.mapCategories,
    transactionsDette: state.paginate.transactionsDette.entities,
    transactionsDetteCriteria: state.paginate.transactionsDette.criteria,
    transactionsDetteSize: state.paginate.transactionsDette.total_size,
});

const dispatch2props = dispatch => ({
    updateCriteriaByObject: (object: any) => dispatch(actions.updateCriteriaByObject(object)),
    fetch: (c?: TransactionCriteria) => dispatch(fetchTransactionsDette(c))
});

export default compose(
  withI18n,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(TransactionsDette)



// WEBPACK FOOTER //
// ./src/page/Consumer/Transactions/tabs/TransactionsDette.tsx